"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.readingsToCoordinates = exports.fieldServiceActivityToCoordinates = void 0;

var _luxon = require("luxon");

var _chartUtils = require("../chartUtils");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var fieldServiceActivityToCoordinates = function fieldServiceActivityToCoordinates(fieldServiceActivity, timeZone) {
  var y0 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 25;
  var y = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 75;
  var flattenedFieldServiceActivity = (0, _chartUtils.combineFieldServiceActivityByCase)(fieldServiceActivity);
  return flattenedFieldServiceActivity.filter(function (fsa) {
    return !!fsa.createdDate;
  }).map(function (activity) {
    var x0 = _luxon.DateTime.fromISO(activity.createdDate, {
      zone: timeZone
    }).toMillis();

    var closedDateTime = _luxon.DateTime.fromISO(activity.closedDate, {
      zone: timeZone
    });

    var x = closedDateTime.isValid ? closedDateTime.toMillis() : _luxon.DateTime.local().toMillis();
    return _objectSpread({
      x0: x0,
      x: x,
      y0: y0,
      y: y
    }, activity);
  });
};

exports.fieldServiceActivityToCoordinates = fieldServiceActivityToCoordinates;

var readingsToCoordinates = function readingsToCoordinates(timeZone, fieldName, y0) {
  return function (reading) {
    return {
      y: Number(reading[fieldName]),
      x: _luxon.DateTime.fromISO(reading.timestamp, {
        zone: timeZone
      }).toMillis(),
      y0: y0 ? Number(reading[y0]) : 0
    };
  };
};

exports.readingsToCoordinates = readingsToCoordinates;